<qpoint-toolbar>
  <qpoint-toolbar-btn qPointButtonType="primary" (btnClick)="resetForm()">Reset Form</qpoint-toolbar-btn>
  <qpoint-toolbar-btn qPointButtonType="primary" (btnClick)="toggleDisabled()">toggle readonly</qpoint-toolbar-btn>
  <qpoint-toolbar-btn qPointButtonType="primary" (btnClick)="form.markAllAsTouched()">mark all as touched</qpoint-toolbar-btn>
  <qpoint-toolbar-btn qPointButtonType="primary" btnType="submit" formId="demo-form">Submit!</qpoint-toolbar-btn>
</qpoint-toolbar>
<qpoint-content-container>
  <form [formGroup]="form" id="demo-form" (ngSubmit)="submit()" qpointValidationForm>
    <div class="d-flex flex-column my-2">
      <div class="input-label">Username</div>
      <qpoint-reactive-form-input-group>
        <input type="text" class="form-control" formControlName="username" qpointValidationFormControl />
      </qpoint-reactive-form-input-group>
    </div>
    <div class="d-flex flex-column">
      <div class="input-label">Password</div>
      <qpoint-reactive-form-input-group>
        <input type="password" class="form-control" formControlName="password" qpointValidationFormControl />
      </qpoint-reactive-form-input-group>
    </div>
    <div class="d-flex flex-column">
      <div class="input-label">ComboBox</div>
      <qpoint-reactive-form-input-group>
        <qpoint-suggestlist [data]="data$ | async" [textField]="'identifier'" [valueField]="'id'" formControlName="drop1" [placeholder]="'notFound'" qpointValidationFormControl [dropDownVariant]="DropDownVariant.ComboBox"></qpoint-suggestlist>
      </qpoint-reactive-form-input-group>
    </div>
    <div class="d-flex flex-column">
      <div class="input-label">DropDownList</div>
      <qpoint-reactive-form-input-group>
        <qpoint-suggestlist [data]="data$ | async" [textField]="'identifier'" [valueField]="'id'" formControlName="drop2" qpointValidationFormControl [dropDownVariant]="DropDownVariant.DropDownList"></qpoint-suggestlist>
      </qpoint-reactive-form-input-group>
    </div>
    <div class="d-flex flex-column">
      <div class="input-label">MultiSelect</div>
      <qpoint-reactive-form-input-group>
        <qpoint-suggestlist [data]="data$ | async" [textField]="'identifier'" [valueField]="'id'" formControlName="drop3" [placeholder]="'notFound'" qpointValidationFormControl [dropDownVariant]="DropDownVariant.MultiSelect"></qpoint-suggestlist>
      </qpoint-reactive-form-input-group>
    </div>
    <div class="d-flex flex-column">
      <div class="input-label">Date-Picker</div>
      <qpoint-reactive-form-input-group>
        <qpoint-datetime-picker [dayOnly]="true" formControlName="datePicker" qpointValidationFormControl>
        </qpoint-datetime-picker>
      </qpoint-reactive-form-input-group>
    </div>
    <div class="d-flex flex-column">
      <div class="input-label">Date-Time-Picker</div>
      <qpoint-reactive-form-input-group>
        <qpoint-datetime-picker formControlName="dateTimePicker" qpointValidationFormControl>
        </qpoint-datetime-picker>
      </qpoint-reactive-form-input-group>
    </div>
    <div class="d-flex flex-column">
      <div class="input-label">Date-Range-Picker</div>
      <qpoint-reactive-form-input-group>
        <qpoint-multi-view-date-range-picker formControlName="dateRangePicker" qpointValidationFormControl>
        </qpoint-multi-view-date-range-picker>
      </qpoint-reactive-form-input-group>
    </div>
    <div class="d-flex flex-column">
      <div class="input-label">Date-Time-Picker with Min- and Max-Value</div>
      <qpoint-reactive-form-input-group  [qpointFormControl]="dateTimePickerMinMax" [isSubmitted]="dateTimePickerMinMax.touched || dateTimePickerMinMax.dirty">
        <qpoint-datetime-picker formControlName="dateTimePickerMinMax" qpointValidationFormControl [min]="minDate" [max]="maxDate">
        </qpoint-datetime-picker>
      </qpoint-reactive-form-input-group>
    </div>    
    <div class="d-flex flex-column">
      <div class="input-label">Inline-Edit</div>
      <qpoint-reactive-form-input-group>
        <qpoint-inline-editing-input
          [activeInlineEditing]="true"
          formControlName="inlineEdit"
          [infoMessageOnEdit]="'Ich bin ein Edit-Text'"
          qpointValidationFormControl>
        </qpoint-inline-editing-input>
      </qpoint-reactive-form-input-group>
    </div>
  </form>
</qpoint-content-container>
